import { FEATURES_LIMIT, type PanelSpecGroup } from './panel-types'
import { SpecRow } from './spec-row'

export const SpecsList = ({ specs }: { specs: PanelSpecGroup[] }) => (
  <div className="border-t border-slate-100 px-5 pt-4 pb-5 lg:px-6 lg:pb-6">
    <div className="grid grid-cols-1 gap-x-8 min-[768px]:grid-cols-2 min-[1200px]:grid-cols-3">
      {specs.map((spec, index) => (
        <SpecRow key={spec.id} spec={spec} expandable={index >= FEATURES_LIMIT} />
      ))}
    </div>
    {specs.length > FEATURES_LIMIT && <div className="mt-4" data-show-more-trigger="" />}
  </div>
)
